var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createSlice } from '@reduxjs/toolkit';
import { Theme } from './theme-types';
var storageTheme = localStorage.getItem('theme');
var preferedColorScheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? Theme.DARK : Theme.LIGHT;
var initialState = {
    type: storageTheme || preferedColorScheme,
};
var themeReducer = createSlice({
    name: 'theme',
    initialState: initialState,
    reducers: {
        changeTheme: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { type: payload }));
        },
    },
});
export var changeTheme = themeReducer.actions.changeTheme;
export default themeReducer.reducer;
